// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___gC3z-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/WhiteLabelFooter/WhiteLabelFooter.scss
// module id = bzca
// module chunks = 57